module.exports = __webpack_public_path__ + "img/btnImg.e9a1f1cf.png";